import React, { useState, useEffect } from 'react';
import './prepLaunchPod.css';

const TransitionPage = ({ setShowTransitionPage, cancel = false }) => {
    const [message, setMessage] = useState(
        "We're customizing your session and tailor making it as per your requirement. Please hang tight..."
    );
    const [showBackButton, setShowBackButton] = useState(false);

    useEffect(() => {
        /* ❶ normal 60‑second fallback */
        const timer = setTimeout(() => {
            setMessage(
                "We're currently experiencing high request traffic. Please try again later."
            );
            setShowBackButton(true);
        }, 65000);

        /* ❷ close instantly if parent signals that the URL has arrived */
        if (cancel) {
            clearTimeout(timer);
            setShowTransitionPage(false);
        }

        return () => clearTimeout(timer);
    }, [cancel, setShowTransitionPage]);

    const handleBack = () => setShowTransitionPage(false);

    return (
        <div className="transition-page-container">
            <div className="loader" />
            <div className="transition-message">{message}</div>
            <button
                className={`back-button ${showBackButton ? 'show' : ''}`}
                onClick={handleBack}
            >
                Back
            </button>
        </div>
    );
};

export default TransitionPage;
